// extracted by mini-css-extract-plugin
module.exports = {"logo-bar":"logo-bar_component_logo-bar__F0cjp","logo":"logo-bar_component_logo__db_te"};